import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {Link} from 'shells/link/link';
import {Modal} from 'shells/modal/modal';
import {ModalSubheader} from 'shells/typography/modal-subheader';

import {closeAllLimitsModal} from './limits-actions';
import * as ModalState from './limits-selectors';
import {TrialLimitsTable} from './trial-limits-table/trial-limits-table';
import {useGetAllLimits} from './use-get-all-limits';

// This modal is used to tell trials they're above the base foundation plan limits
// they're not caught off guard when they go to purchase a plan
export function AllLimitsModal() {
    const dispatch = useDispatch();

    const shouldLinkToBilling = useSelector((state) => ModalState.getShouldLinkToBilling(state));
    const titleText = useSelector((state) => ModalState.getTitleText(state));
    const {allLimits} = useGetAllLimits();

    const handleClose = () => {
        dispatch(closeAllLimitsModal());
    };

    if (allLimits) {
        return (
            <Modal
                trapFocus={true}
                isOpen={true}
                onClose={handleClose}
                minWidth={900}
                fitHeight={true}
            >
                <ModalSubheader>
                    {titleText ||
                        `Based on your trial usage, you’ll need to purchase a Nutshell
                    ${allLimits.minimumPlanName} plan.`}
                    <br />
                    {shouldLinkToBilling ? (
                        <Link
                            variant='primary'
                            size='big'
                            newTab={true}
                            href='/setup/billing/sales'
                        >
                            Explore all plan options on our billing page to learn more
                        </Link>
                    ) : undefined}
                </ModalSubheader>
                <TrialLimitsTable features={allLimits.limits} />
            </Modal>
        );
    }

    return null;
}
